import ArrowDown from '@/common/assets/icons/arrowDown.svg?react';
import createAttachment from '@/common/components/base/input/base/helpers/createAttachment.ts';
const ArrowDownAttachment = createAttachment({
  element: <ArrowDown />,
  size: 'small',
});

export default ArrowDownAttachment;
